import { render, staticRenderFns } from "./TextWithLabel.vue?vue&type=template&id=29ca21d8&"
import script from "./TextWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./TextWithLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports